// TODO download modules ///////////////////////////////////////////////////////////////////////////////////////////////
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// TODO custom modules /////////////////////////////////////////////////////////////////////////////////////////////////
import * as components from "../../js/components";
import * as constants from "../../js/constants";
import * as utils from "../../js/utils";
import * as actions from "../../js/actions";
// TODO default export const page //////////////////////////////////////////////////////////////////////////////////////
export const ChangeProfilePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [secretQuestion, secretQuestionSet] = useState("");
  const [secretAnswer, secretAnswerSet] = useState("");
  const [email, emailSet] = useState("");
  const [avatar, avatarSet] = useState(null);
  const [password, passwordSet] = useState("");
  const [password2, password2Set] = useState("");
  const [showPassword, showPasswordSet] = useState(false);
  const [showPassword2, showPassword2Set] = useState(false);

  const userDetailStore = useSelector((state) => state.userDetailStore);
  const { data: dataUserDetails } = userDetailStore;

  const userChangeStore = useSelector((state) => state.userChangeStore);
  const { load: loadUserChange, data: dataUserChange, error: errorUserChange, fail: failUserChange } = userChangeStore;

  // Первый вход = секретный вопрос ещё не заполнен
  const isFirstLogin = dataUserDetails &&
    dataUserDetails["user_model"] &&
    !dataUserDetails["user_model"]["secret_question_char_field"];

  useEffect(() => {
    if (dataUserDetails && dataUserDetails["user_model"]) {
      if (dataUserDetails["user_model"]["secret_question_char_field"])
        secretQuestionSet(dataUserDetails["user_model"]["secret_question_char_field"]);
      if (dataUserDetails["user_model"]["secret_answer_char_field"])
        secretAnswerSet(dataUserDetails["user_model"]["secret_answer_char_field"]);
      if (dataUserDetails["user_model"]["email_field"])
        emailSet(dataUserDetails["user_model"]["email_field"]);
      passwordSet("");
      password2Set("");
    } else {
      dispatch(utils.ActionConstructorUtility(
        { "Action-type": "USER_DETAIL" },
        "/api/auth/user/detail/", "POST", 30000, constants.USER_DETAIL, false
      ));
    }
  }, [dataUserDetails]);

  useEffect(() => {
    if (dataUserChange) {
      utils.Sleep(10).then(() => {
        dispatch(actions.userLogoutAction());
        navigate("/login");
      });
    }
  }, [dataUserChange]);

  const handlerChangeSubmit = (e) => {
    e.preventDefault();
    dispatch(utils.ActionConstructorUtility(
      { "Action-type": "USER_CHANGE", secretQuestion, secretAnswer, email, avatar, password, password2 },
      "/api/auth/user/change/", "POST", 30000, constants.USER_CHANGE
    ));
  };

  const handlerChangeReset = (e) => {
    try { e.preventDefault(); } catch (err) {}
    secretQuestionSet(""); secretAnswerSet(""); emailSet("");
    passwordSet(""); password2Set("");
  };

  // Helpers
  const inputStyle = (focused) => ({
    paddingLeft: 42, height: 48, borderRadius: 10, fontSize: 14,
    border: `1.5px solid ${focused ? "#1753A9" : "#E4E7EC"}`,
    transition: "border-color .15s", width: "100%",
    display: "block", background: "#fff", color: "#1C2128",
    outline: "none",
  });

  const Field = ({ label, hint, required, icon, children }) => (
    <div style={{ marginBottom: 18 }}>
      <label style={{ fontSize: 12.5, fontWeight: 600, color: "#5B6472", display: "block", marginBottom: 6 }}>
        {label}
        {required
          ? <span style={{ color: "#C0392B", marginLeft: 4 }}>*</span>
          : <span style={{ color: "#9BA6B2", marginLeft: 4, fontWeight: 400 }}>(необязательно)</span>
        }
      </label>
      <div style={{ position: "relative" }}>
        <i className={`fa-solid ${icon}`} style={{
          position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)",
          color: "#9BA6B2", fontSize: 15, pointerEvents: "none", zIndex: 1
        }} />
        {children}
      </div>
      {hint && <div style={{ fontSize: 11, color: "#9BA6B2", marginTop: 4 }}>{hint}</div>}
    </div>
  );

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#0F1923", fontFamily: "'Inter', Arial, sans-serif" }}>

      {/* ===== ЛЕВАЯ ЧАСТЬ — фото ===== */}
      <div style={{ flex: "1 1 42%", position: "relative", overflow: "hidden" }} className="km-login-photo-panel" >
        <div style={{
          position: "absolute", inset: 0,
          backgroundImage: "url('/static/img/background_3.jpg')",
          backgroundSize: "cover", backgroundPosition: "center 38%",
        }} />
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(160deg, rgba(12,30,58,.80) 0%, rgba(20,45,80,.56) 34%, rgba(90,60,25,.30) 64%, rgba(150,95,30,.08) 100%)",
        }} />
        <div style={{ position: "relative", zIndex: 1, padding: "44px 48px", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 44, height: 44, borderRadius: 10, background: "rgba(255,255,255,.13)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img src="/static/img/logo.svg" alt="КМ" style={{ height: 26, filter: "brightness(0) invert(1)" }} />
            </div>
            <div style={{ color: "#fff", fontWeight: 700, fontSize: 14, lineHeight: 1.3 }}>
              АО «Костанайские<br />Минералы»
            </div>
          </div>
          <div>
            {isFirstLogin ? (
              <>
                <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(242,169,0,.18)", border: "1px solid rgba(242,169,0,.4)", borderRadius: 8, padding: "6px 12px", marginBottom: 14 }}>
                  <i className="fa-solid fa-star" style={{ color: "#F2A900", fontSize: 12 }} />
                  <span style={{ color: "#F2A900", fontSize: 11, fontWeight: 700, letterSpacing: ".07em", textTransform: "uppercase" }}>Первый вход в систему</span>
                </div>
                <div style={{ color: "#fff", fontSize: 24, fontWeight: 700, lineHeight: 1.3, marginBottom: 10, maxWidth: 380 }}>
                  Добро пожаловать!<br />Настройте профиль
                </div>
                <div style={{ color: "rgba(255,255,255,.65)", fontSize: 13.5, lineHeight: 1.65, maxWidth: 360 }}>
                  Заполните секретный вопрос и пароль — это нужно для безопасности вашего аккаунта. Без этих данных система будет перенаправлять вас на эту страницу при каждом входе.
                </div>
              </>
            ) : (
              <>
                <div style={{ color: "#F2A900", fontSize: 11, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", marginBottom: 10 }}>Управление профилем</div>
                <div style={{ color: "#fff", fontSize: 24, fontWeight: 700, lineHeight: 1.3, marginBottom: 10 }}>
                  Изменение данных профиля
                </div>
                <div style={{ color: "rgba(255,255,255,.65)", fontSize: 13.5, lineHeight: 1.65, maxWidth: 360 }}>
                  После сохранения вы будете автоматически выведены из системы и перенаправлены на страницу входа.
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ===== ПРАВАЯ ЧАСТЬ — форма ===== */}
      <div style={{ flex: "1 1 58%", background: "#fff", overflowY: "auto", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 32px", position: "relative" }}>

        <div className="km-login-mobile-logo" style={{ display: "none", marginBottom: 28, textAlign: "center" }}>
          <img src="/static/img/logo.png" alt="КМ" style={{ height: 42 }} />
        </div>

        <div style={{ width: "100%", maxWidth: 520 }}>

          {/* Заголовок */}
          <div style={{ marginBottom: 24 }}>
            {isFirstLogin && (
              <div style={{ display: "inline-flex", alignItems: "center", gap: 7, background: "#FEF4DD", border: "1px solid #F2D88B", borderRadius: 8, padding: "5px 12px", marginBottom: 10, fontSize: 12.5, color: "#8A6000", fontWeight: 600 }}>
                <i className="fa-solid fa-star" style={{ fontSize: 11 }} />
                Первый вход — заполните данные профиля
              </div>
            )}
            <h1 style={{ fontSize: 22, fontWeight: 800, color: "#1C2128", margin: "0 0 4px" }}>
              {isFirstLogin ? "Настройка профиля" : "Изменение профиля"}
            </h1>
            <p style={{ fontSize: 13.5, color: "#5B6472", margin: 0 }}>
              {isFirstLogin
                ? "Заполните все обязательные поля для активации аккаунта"
                : "Измените нужные поля и нажмите «Сохранить»"}
            </p>
          </div>

          {/* Статус */}
          {errorUserChange && (
            <div style={{ background: "#FBEAEA", border: "1px solid #F5C6C6", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#C0392B", display: "flex", alignItems: "center", gap: 8 }}>
              <i className="fa-solid fa-circle-exclamation" />
              {typeof errorUserChange === "string" ? errorUserChange : "Ошибка при сохранении данных"}
            </div>
          )}
          {failUserChange && (
            <div style={{ background: "#FBEAEA", border: "1px solid #F5C6C6", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#C0392B" }}>
              <i className="fa-solid fa-wifi m-0 p-1" /> Ошибка соединения с сервером
            </div>
          )}
          {dataUserChange && (
            <div style={{ background: "#E8F8EF", border: "1px solid #A8DEC0", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#1E9E6B" }}>
              <i className="fa-solid fa-circle-check m-0 p-1" /> Данные успешно сохранены! Выход из системы...
            </div>
          )}

          <form onSubmit={handlerChangeSubmit}>

            {/* Разделитель */}
            <div style={{ fontSize: 11, fontWeight: 700, color: "#9BA6B2", textTransform: "uppercase", letterSpacing: ".08em", marginBottom: 12, paddingBottom: 8, borderBottom: "1px solid #E4E7EC" }}>
              <i className="fa-solid fa-shield-halved m-0 p-1" style={{ color: "#1753A9" }} />
              Данные для восстановления доступа
            </div>

            {/* Секретный вопрос */}
            <Field label="Секретный вопрос" hint="Кириллица, цифры и пробел · от 4 до 32 символов" required icon="fa-question-circle">
              <input
                type="text"
                className="form-control"
                value={secretQuestion}
                placeholder="Придумайте секретный вопрос..."
                required
                minLength="4" maxLength="32"
                onChange={(e) => secretQuestionSet(e.target.value.replace(utils.GetRegexType({ numbers: true, cyrillic: true, space: true }), ""))}
                style={inputStyle(false)}
                onFocus={(e) => e.target.style.borderColor = "#1753A9"}
                onBlur={(e) => e.target.style.borderColor = "#E4E7EC"}
              />
            </Field>

            {/* Секретный ответ */}
            <Field label="Ответ на секретный вопрос" hint="Кириллица, цифры и пробел · от 4 до 32 символов" required icon="fa-message">
              <input
                type="text"
                className="form-control"
                value={secretAnswer}
                placeholder="Введите ответ..."
                required
                minLength="4" maxLength="32"
                onChange={(e) => secretAnswerSet(e.target.value.replace(utils.GetRegexType({ numbers: true, cyrillic: true, space: true }), ""))}
                style={inputStyle(false)}
                onFocus={(e) => e.target.style.borderColor = "#1753A9"}
                onBlur={(e) => e.target.style.borderColor = "#E4E7EC"}
              />
            </Field>

            {/* Email */}
            <Field label="Email для восстановления" hint="Латиница, цифры, знаки почты · не более 300 символов" icon="fa-envelope">
              <input
                type="email"
                className="form-control"
                value={email}
                placeholder="example@km.kz"
                minLength="1" maxLength="300"
                onChange={(e) => emailSet(e.target.value.replace(utils.GetRegexType({ numbers: true, latin: true, lowerSpace: true, email: true }), ""))}
                autoComplete="off"
                style={inputStyle(false)}
                onFocus={(e) => e.target.style.borderColor = "#1753A9"}
                onBlur={(e) => e.target.style.borderColor = "#E4E7EC"}
              />
            </Field>

            {/* Разделитель */}
            <div style={{ fontSize: 11, fontWeight: 700, color: "#9BA6B2", textTransform: "uppercase", letterSpacing: ".08em", marginBottom: 12, paddingBottom: 8, borderBottom: "1px solid #E4E7EC", marginTop: 6 }}>
              <i className="fa-solid fa-lock m-0 p-1" style={{ color: "#1753A9" }} />
              Новый пароль
            </div>

            {/* Пароль */}
            <Field label="Новый пароль" hint="Латиница, цифры и _ · от 8 до 16 символов" required icon="fa-key">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                className="form-control"
                value={password}
                placeholder="Введите новый пароль..."
                required
                minLength="8" maxLength="16"
                onChange={(e) => passwordSet(e.target.value.replace(utils.GetRegexType({ numbers: true, latin: true, lowerSpace: true }), ""))}
                autoComplete="current-password"
                style={{ ...inputStyle(false), paddingRight: 48 }}
                onFocus={(e) => e.target.style.borderColor = "#1753A9"}
                onBlur={(e) => e.target.style.borderColor = "#E4E7EC"}
              />
              <button type="button" onClick={() => showPasswordSet(!showPassword)}
                style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 46, background: "none", border: "none", cursor: "pointer", color: "#9BA6B2" }}>
                <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`} style={{ fontSize: 14 }} />
              </button>
            </Field>

            {/* Пароль 2 */}
            <Field label="Повторите новый пароль" hint="Должен совпадать с паролем выше" required icon="fa-key">
              <input
                type={showPassword2 ? "text" : "password"}
                id="password2"
                className="form-control"
                value={password2}
                placeholder="Повторите пароль..."
                required
                minLength="8" maxLength="16"
                onChange={(e) => password2Set(e.target.value.replace(utils.GetRegexType({ numbers: true, latin: true, lowerSpace: true }), ""))}
                autoComplete="current-password"
                style={{
                  ...inputStyle(false),
                  paddingRight: 48,
                  borderColor: password2 && password !== password2 ? "#C0392B" : "#E4E7EC"
                }}
                onFocus={(e) => e.target.style.borderColor = "#1753A9"}
                onBlur={(e) => e.target.style.borderColor = password2 && password !== password2 ? "#C0392B" : "#E4E7EC"}
              />
              <button type="button" onClick={() => showPassword2Set(!showPassword2)}
                style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 46, background: "none", border: "none", cursor: "pointer", color: "#9BA6B2" }}>
                <i className={`fa-solid ${showPassword2 ? "fa-eye-slash" : "fa-eye"}`} style={{ fontSize: 14 }} />
              </button>
            </Field>

            {/* Несовпадение паролей */}
            {password2 && password !== password2 && (
              <div style={{ background: "#FBEAEA", border: "1px solid #F5C6C6", borderRadius: 8, padding: "8px 12px", marginBottom: 16, fontSize: 12.5, color: "#C0392B", display: "flex", alignItems: "center", gap: 6 }}>
                <i className="fa-solid fa-triangle-exclamation" /> Пароли не совпадают
              </div>
            )}

            {/* Кнопки */}
            <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
              <button
                type="submit"
                disabled={loadUserChange || (password2 && password !== password2)}
                style={{
                  flex: 1, height: 50, borderRadius: 12, border: "none",
                  background: loadUserChange ? "#B8C8E0" : "#1753A9",
                  color: "#fff", fontSize: 15, fontWeight: 700,
                  cursor: loadUserChange ? "not-allowed" : "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                  transition: "background .15s",
                }}
              >
                {loadUserChange
                  ? <><span className="spinner-border spinner-border-sm" style={{ width: 18, height: 18 }} /> Сохраняем...</>
                  : <><i className="fa-solid fa-circle-check" /> Сохранить данные</>}
              </button>
              <button
                type="reset"
                onClick={handlerChangeReset}
                style={{
                  flex: "0 0 auto", height: 50, borderRadius: 12, padding: "0 20px",
                  background: "none", border: "1.5px solid #E4E7EC",
                  color: "#5B6472", fontSize: 14, fontWeight: 600, cursor: "pointer",
                  transition: "border-color .15s",
                }}
                onMouseEnter={(e) => e.target.style.borderColor = "#1753A9"}
                onMouseLeave={(e) => e.target.style.borderColor = "#E4E7EC"}
              >
                <i className="fa-solid fa-rotate-left m-0 p-1" /> Сбросить
              </button>
            </div>

          </form>
        </div>

        <div style={{ position: "absolute", bottom: 16, left: 0, right: 0, textAlign: "center", fontSize: 11, color: "#B0B8C4" }}>
          © 2026 АО «Костанайские Минералы»
        </div>
      </div>

      <style>{`
        @media (min-width: 768px) { .km-login-photo-panel { display: flex !important; } .km-login-mobile-logo { display: none !important; } }
        @media (max-width: 767px) { .km-login-photo-panel { display: none !important; } .km-login-mobile-logo { display: block !important; } }
      `}</style>

    </div>
  );
};
